<app-header [currentModule]="moduloEnum" [currentModuleFuncionality]="funcionalidadeEnum"></app-header>

<div class="container-header">
    <div class="container-header-inner">

        <div class="title-wrapper mb-4">
            <div>
                <h1 class="title-default">Fluxo de Caixa</h1>
                <p class="welcome-message">
                    <button mat-icon-button type="button" (click)="voltar()" aria-label="Voltar para relatórios de finanças">
                        <mat-icon>arrow_back</mat-icon>
                    </button>
                    Acompanhe entradas, saídas e saldo do caixa por período.
                </p>
            </div>
        </div>

        @if (carregandoLookups) {
            <div class="row">
                <div class="col-12 mb-4">
                    <app-loading-box [height]="'30'" [width]="'250'" [margin]="'0 0 20px 0'"></app-loading-box>
                    <div class="row">
                        <div class="col-12 mb-3">
                            <app-loading-box [height]="'100'"></app-loading-box>
                        </div>
                    </div>
                </div>
            </div>
        } @else {

        <!-- ─── Filter section ─── -->
        <section class="section-container filtros-section" [class.filtros-hidden]="!filtrosVisiveis">
            <div class="filtros-heading">
                <div class="filtros-heading-title">
                    <mat-icon>filter_alt</mat-icon>
                    <span>Filtros de pesquisa</span>
                </div>
                <div class="favoritos-toolbar">
                    <mat-form-field appearance="outline" class="favoritos-field" subscriptSizing="dynamic">
                        <mat-label>Filtros favoritos</mat-label>
                        <mat-select [formControl]="$any(form.controls['favoritoSelecionado'])"
                            (selectionChange)="carregarFavoritoSelecionado()">
                            <mat-option [value]="null">Selecionar favorito</mat-option>
                            @for (favorito of favoritos; track favorito.idRelatorioFiltroFavorito) {
                                <mat-option [value]="getFavoritoValue(favorito)">{{ favorito.nome }}</mat-option>
                            }
                        </mat-select>
                    </mat-form-field>
                    @if (hasFavoritoSelecionado || hasAlgumFiltroPreenchido) {
                        <button type="button" mat-stroked-button class="btn-secondary favoritar-button" (click)="favoritarFiltros()">
                            <mat-icon>{{ hasFavoritoSelecionado ? 'delete' : 'star' }}</mat-icon>
                            {{ hasFavoritoSelecionado ? 'Remover favorito' : 'Favoritar filtros' }}
                        </button>
                    }
                </div>
            </div>

            <form [formGroup]="form" class="filtros-body">
                <div class="row g-3">
                    <div class="col-xl-4 col-lg-5 col-12 border-end-desktop">
                        <div class="d-flex flex-column gap-3 h-100">
                            <div class="field-group mb-0 campo-periodo">
                                <label class="field-caption mb-3">Período de referência</label>
                                <div class="periodo-toggle mb-0">
                                    @for (opcao of granularidadeOpcoes; track opcao.id) {
                                        <button type="button" class="periodo-chip"
                                            [class.periodo-chip-active]="form.get('granularidade')?.value === opcao.id"
                                            (click)="selecionarGranularidade(opcao.id)">
                                            {{ opcao.descricao }}
                                        </button>
                                    }
                                </div>
                            </div>

                            <div class="flex-grow-1">
                                @if (isDiario) {
                                    <div class="mes-picker">
                                        <mat-form-field appearance="outline" subscriptSizing="dynamic" class="w-100 mes-picker-field">
                                            <button matPrefix type="button" mat-icon-button class="mes-nav-btn" (click)="navegarMes(-1)"
                                                aria-label="Mês anterior">
                                                <mat-icon>chevron_left</mat-icon>
                                            </button>
                                            <input matInput class="text-center mes-input-fw" formControlName="mesAno"
                                                placeholder="MM/AAAA" (blur)="normalizarMesAno()" autocomplete="off">
                                            <button matSuffix type="button" mat-icon-button class="mes-nav-btn" (click)="navegarMes(1)"
                                                aria-label="Próximo mês">
                                                <mat-icon>chevron_right</mat-icon>
                                            </button>
                                        </mat-form-field>
                                    </div>
                                } @else {
                                    <div class="mes-picker">
                                        <mat-form-field appearance="outline" subscriptSizing="dynamic" class="w-100 mes-picker-field">
                                            <mat-label>Ano</mat-label>
                                            <button matPrefix type="button" mat-icon-button class="mes-nav-btn" (click)="navegarAno(-1)"
                                                aria-label="Ano anterior">
                                                <mat-icon>chevron_left</mat-icon>
                                            </button>
                                            <input matInput class="text-center mes-input-fw" formControlName="anoVisualizacao"
                                                placeholder="AAAA" (blur)="normalizarAno()" autocomplete="off">
                                            <button matSuffix type="button" mat-icon-button class="mes-nav-btn" (click)="navegarAno(1)"
                                                aria-label="Próximo ano">
                                                <mat-icon>chevron_right</mat-icon>
                                            </button>
                                        </mat-form-field>
                                    </div>
                                }
                            </div>
                        </div>
                    </div>

                    <div class="col-xl-8 col-lg-7 col-12 filtros-campos-direita">
                        <div class="row g-3 filtros-campos-direita-inner">
                            <div class="col-md-6 col-12">
                                <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
                                    <mat-label>Conta financeira</mat-label>
                                    <mat-select formControlName="idContaFinanceira">
                                        <mat-option [value]="null">Consolidado (todas)</mat-option>
                                        @for (conta of listaContasFinanceiras; track conta.idContaFinanceira) {
                                            <mat-option [value]="conta.idContaFinanceira">{{ conta.descricao }}</mat-option>
                                        }
                                    </mat-select>
                                </mat-form-field>
                            </div>

                            <div class="col-md-6 col-12">
                                <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
                                    <mat-label>Centro de custo</mat-label>
                                    <mat-select formControlName="idCentroCusto">
                                        <mat-option [value]="null">Todos</mat-option>
                                        @for (cc of listaCentrosCusto; track cc.idCentroCusto) {
                                            <mat-option [value]="cc.idCentroCusto">{{ cc.codigo ? cc.codigo + ' — ' : '' }}{{ cc.nome }}</mat-option>
                                        }
                                    </mat-select>
                                </mat-form-field>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="filtros-footer">
                    <button type="button" mat-flat-button class="btn-primary" (click)="gerar()"
                        [disabled]="carregandoLookups || carregandoRelatorio">
                        @if (!carregandoRelatorio) {
                            <mat-icon>search</mat-icon>
                            Gerar relatório
                        } @else {
                            <mat-spinner diameter="20"></mat-spinner>
                        }
                    </button>
                </div>
            </form>
        </section>

        <!-- ─── Loading results ─── -->
        @if (carregandoRelatorio) {
            <div class="row">
                <div class="col-12 mb-4">
                    <app-loading-box [height]="'48'" [margin]="'0 0 20px 0'"></app-loading-box>
                    <app-loading-box [height]="'300'"></app-loading-box>
                </div>
            </div>
        } @else if (consultaGerada && possuiResultados) {

        <!-- ─── Toolbar ─── -->
        <section class="toolbar-card">
            <div class="toolbar-actions">
                <button type="button" mat-stroked-button class="btn-secondary" (click)="toggleFiltros()">
                    <mat-icon>tune</mat-icon>
                    {{ filtrosVisiveis ? 'Ocultar filtros' : 'Exibir filtros' }}
                </button>
                <button type="button" mat-stroked-button class="btn-secondary icon-only" (click)="imprimir()"
                    matTooltip="Imprimir" aria-label="Imprimir relatório">
                    <mat-icon>print</mat-icon>
                </button>
                <button type="button" mat-stroked-button class="btn-secondary icon-only" (click)="downloadCsv()"
                    matTooltip="Download CSV" aria-label="Download CSV do relatório">
                    <mat-icon>download</mat-icon>
                </button>
            </div>
        </section>

        <section class="resultado-section">

            <!-- ─── Chart ─── -->
            <article class="tabela-card chart-card">
                <div class="chart-body">
                    <div class="chart-header-inline">
                        <div>
                            <span class="chart-title">{{ isDiario ? 'Fluxo do Mês' : 'Fluxo de Caixa (Mensal)' }}</span>
                            <span class="chart-subtitle">{{ isDiario ? 'Comparativo de movimentações previstas vs realizadas por dia — ' + periodoDescricaoGerado : 'Comparativo de movimentações previstas vs realizadas por mês' }}</span>
                        </div>
                    </div>
                    <div id="chart-fluxo" class="chart-area"></div>
                </div>
            </article>


            <!-- ─── Daily table ─── -->
            @if (isDiario && diarioResponse) {
                <article class="tabela-card detalhes-card">
                    <div class="detalhes-header">
                        <mat-icon>calendar_today</mat-icon>
                        <span>Movimentações diárias — {{ periodoDescricaoGerado }}</span>
                    </div>
                    <div class="detalhes-grupo">
                        <table class="detalhes-table">
                            <thead>
                                <tr>
                                    <th class="col-data-dia" rowspan="2">Data / dia</th>
                                    <th class="col-matriz-mes" colspan="2">Recebimentos</th>
                                    <th class="col-matriz-mes" colspan="2">Pagamentos</th>
                                    <th class="col-moeda text-end" rowspan="2">Transf. entrada</th>
                                    <th class="col-moeda text-end" rowspan="2">Transf. saída</th>
                                    <th class="col-matriz-mes col-saldo" colspan="2">Saldo</th>
                                </tr>
                                <tr class="subheader-row">
                                    <th class="col-matriz-val text-end">PREVISTO</th>
                                    <th class="col-matriz-val text-end">REALIZADO</th>
                                    <th class="col-matriz-val text-end">PREVISTO</th>
                                    <th class="col-matriz-val text-end">REALIZADO</th>
                                    <th class="col-matriz-val text-end">PREVISTO</th>
                                    <th class="col-matriz-val text-end">REALIZADO</th>
                                </tr>
                            </thead>
                            <tbody>
                                @for (item of diarioItensTabela; track item.data) {
                                    <tr>
                                        <td class="col-data-dia">
                                            <span class="data-dia-date">{{ formatarData(item.data) }}</span>
                                            <span class="data-dia-weekday">{{ item.diaSemana }}</span>
                                        </td>
                                        <td class="col-moeda text-end">{{ item.recebimentosPrevisto > 0 ? formatarMoeda(item.recebimentosPrevisto) : '—' }}</td>
                                        <td class="col-moeda text-end valor-receita">
                                            @if (item.recebimentos > 0) {
                                                <span class="valor-drilldown" (click)="abrirDetalheDiario(item, tipoDetalheEnum.Recebimento, 'Recebimentos')">{{ formatarMoeda(item.recebimentos) }}</span>
                                            } @else { — }
                                        </td>
                                        <td class="col-moeda text-end">{{ item.pagamentosPrevisto > 0 ? formatarMoeda(item.pagamentosPrevisto) : '—' }}</td>
                                        <td class="col-moeda text-end valor-despesa">
                                            @if (item.pagamentos > 0) {
                                                <span class="valor-drilldown" (click)="abrirDetalheDiario(item, tipoDetalheEnum.Pagamento, 'Pagamentos')">{{ formatarMoeda(item.pagamentos) }}</span>
                                            } @else { — }
                                        </td>
                                        <td class="col-moeda text-end">
                                            @if (item.transferenciasEntrada > 0) {
                                                <span class="valor-drilldown" (click)="abrirDetalheDiario(item, tipoDetalheEnum.TransferenciaEntrada, 'Transferências de Entrada')">{{ formatarMoeda(item.transferenciasEntrada) }}</span>
                                            } @else { — }
                                        </td>
                                        <td class="col-moeda text-end">
                                            @if (item.transferenciasSaida > 0) {
                                                <span class="valor-drilldown" (click)="abrirDetalheDiario(item, tipoDetalheEnum.TransferenciaSaida, 'Transferências de Saída')">{{ formatarMoeda(item.transferenciasSaida) }}</span>
                                            } @else { — }
                                        </td>
                                        <td class="col-moeda text-end">{{ formatarMoeda(item.saldoPrevisto) }}</td>
                                        <td class="col-moeda text-end col-saldo"
                                            [class.valor-receita]="item.saldoFinal > 0"
                                            [class.valor-despesa]="item.saldoFinal < 0">
                                            {{ formatarMoeda(item.saldoFinal) }}
                                        </td>
                                    </tr>
                                }
                                @if (diarioItensTabela.length === 0) {
                                    <tr>
                                        <td colspan="9" class="detalhes-empty">Nenhuma movimentação encontrada no período.</td>
                                    </tr>
                                }
                            </tbody>
                            <tfoot>
                                <tr class="total-row">
                                    <td><strong>Total</strong></td>
                                    <td class="col-moeda text-end"><strong>{{ formatarMoeda(diarioResponse.totalRecebimentosPrevisto) }}</strong></td>
                                    <td class="col-moeda text-end"><strong>{{ formatarMoeda(diarioResponse.totalRecebimentos) }}</strong></td>
                                    <td class="col-moeda text-end"><strong>{{ formatarMoeda(diarioResponse.totalPagamentosPrevisto) }}</strong></td>
                                    <td class="col-moeda text-end"><strong>{{ formatarMoeda(diarioResponse.totalPagamentos) }}</strong></td>
                                    <td class="col-moeda text-end"><strong>{{ formatarMoeda(diarioResponse.totalTransferenciasEntrada) }}</strong></td>
                                    <td class="col-moeda text-end"><strong>{{ formatarMoeda(diarioResponse.totalTransferenciasSaida) }}</strong></td>
                                    <td class="col-moeda text-end"><strong>{{ formatarMoeda(diarioResponse.saldoFinalPrevisto) }}</strong></td>
                                    <td class="col-moeda text-end col-saldo"
                                        [class.valor-receita]="diarioResponse.saldoFinal > 0"
                                        [class.valor-despesa]="diarioResponse.saldoFinal < 0">
                                        <strong>{{ formatarMoeda(diarioResponse.saldoFinal) }}</strong>
                                    </td>
                                </tr>
                            </tfoot>
                        </table>
                    </div>
                </article>
            }

            <!-- ─── Monthly unified matrix ─── -->
            @if (!isDiario && mensalResponse) {
                <article class="tabela-card detalhes-card matriz-card">
                    <div class="detalhes-header">
                        <mat-icon>calendar_month</mat-icon>
                        <span>Matriz Mensal — {{ anoVisualizacaoControl.value }}</span>
                        <span class="detalhes-header-hint">Clique em uma linha para expandir/colapsar</span>
                        <div class="matriz-scroll-arrows">
                            <button type="button" mat-icon-button class="btn-scroll-arrow" (click)="scrollMatriz(matrizRef, -1)" matTooltip="Rolar esquerda">
                                <mat-icon>chevron_left</mat-icon>
                            </button>
                            <button type="button" mat-icon-button class="btn-scroll-arrow" (click)="scrollMatriz(matrizRef, 1)" matTooltip="Rolar direita">
                                <mat-icon>chevron_right</mat-icon>
                            </button>
                        </div>
                    </div>
                    <div class="detalhes-grupo matriz-scroll-container" #matrizRef>
                        <table class="detalhes-table tabela-matriz">
                            <thead>
                                <tr>
                                    <th class="col-matriz-desc">TIPO DO LANÇAMENTO / CATEGORIA</th>
                                    @for (idx of mensalMesesIndicesTabela; track idx) {
                                        <th class="col-matriz-mes" colspan="2">{{ nomesMeses[idx] | uppercase }}/{{ anoVisualizacaoControl.value }}</th>
                                    }
                                    <th class="col-matriz-mes" colspan="2">TOTAL</th>
                                </tr>
                                <tr class="subheader-row">
                                    <th class="col-matriz-desc"></th>
                                    @for (idx of mensalMesesIndicesTabela; track idx) {
                                        <th class="col-matriz-val text-end">VALOR<br>PREVISTO</th>
                                        <th class="col-matriz-val text-end">VALOR<br>REALIZADO</th>
                                    }
                                    <th class="col-matriz-val text-end">VALOR<br>PREVISTO</th>
                                    <th class="col-matriz-val text-end">VALOR<br>REALIZADO</th>
                                </tr>
                            </thead>
                            <tbody>

                                <!-- Saldo do mês anterior -->
                                <tr class="row-matriz-especial">
                                    <td class="col-matriz-desc"><strong>Saldo do mês anterior</strong></td>
                                    @for (idx of mensalMesesIndicesTabela; track idx) {
                                        <td class="col-matriz-val text-end">{{ formatarMoeda(getSaldoMesAnteriorPrevisto(idx)) }}</td>
                                        <td class="col-matriz-val text-end"
                                            [class.valor-receita]="getSaldoMesAnteriorRealizado(idx) > 0"
                                            [class.valor-despesa]="getSaldoMesAnteriorRealizado(idx) < 0">
                                            {{ formatarMoeda(getSaldoMesAnteriorRealizado(idx)) }}
                                        </td>
                                    }
                                    <td class="col-matriz-val text-end">—</td>
                                    <td class="col-matriz-val text-end">—</td>
                                </tr>

                                <!-- Recebimentos section -->
                                <tr class="row-matriz-secao row-matriz-receita" (click)="toggleMatrizSecao('rec')">
                                    <td class="col-matriz-desc">
                                        <button type="button" class="btn-matriz-collapse">
                                            <mat-icon>{{ isSecaoColapsada('rec') ? 'expand_more' : 'expand_less' }}</mat-icon>
                                        </button>
                                        <strong>Recebimentos</strong>
                                    </td>
                                    @for (idx of mensalMesesIndicesTabela; track idx) {
                                        <td class="col-matriz-val text-end">{{ getMensalValor('recebimentosPrevisto', idx) > 0 ? formatarMoeda(getMensalValor('recebimentosPrevisto', idx)) : '—' }}</td>
                                        <td class="col-matriz-val text-end valor-receita">{{ getMensalValor('recebimentosRealizado', idx) > 0 ? formatarMoeda(getMensalValor('recebimentosRealizado', idx)) : '—' }}</td>
                                    }
                                    <td class="col-matriz-val text-end">
                                        <strong>{{ formatarMoeda(getTotalMensal('recebimentosPrevisto')) }}</strong>
                                    </td>
                                    <td class="col-matriz-val text-end valor-receita">
                                        <strong>{{ formatarMoeda(getTotalMensal('recebimentosRealizado')) }}</strong>
                                    </td>
                                </tr>

                                @if (!isSecaoColapsada('rec')) {
                                    @for (cat of mensalResponse.categoriasReceita; track cat.idCategoriaFinanceira) {
                                        @if (isCategoriaVisivel(cat, mensalResponse.categoriasReceita, 'receita')) {
                                            <tr [class.row-cat-nivel-0]="cat.nivel === 0"
                                                [class.row-cat-nivel-1]="cat.nivel === 1"
                                                [class.row-cat-nivel-2]="cat.nivel >= 2"
                                                class="categoria-row categoria-row-entrada"
                                                [class.categoria-row-expanded]="isDetalhesCategoriaExpandido(cat, 'receita')"
                                                [style.--categoria-color]="getCategoriaDrillColor(cat)"
                                                (click)="toggleDetalhesCategoria(cat, 'receita')">
                                                <td class="col-matriz-desc td-categoria-tree" [style.padding-left.px]="20 + cat.nivel * 16">
                                                    @if (temFilhos(cat, mensalResponse.categoriasReceita)) {
                                                        <mat-icon class="btn-cat-collapse" (click)="$event.stopPropagation(); toggleCategoria(cat, 'receita')">{{ isCategoriaColapsada(cat, 'receita') ? 'expand_more' : 'expand_less' }}</mat-icon>
                                                    } @else {
                                                        <span class="cat-indent-spacer"></span>
                                                    }
                                                    <span class="cat-color-dot" [style.background]="getCategoriaDrillColor(cat)"></span>
                                                    {{ cat.descricao }}
                                                    <button type="button" class="btn-cat-drill-toggle"
                                                        [attr.aria-label]="isDetalhesCategoriaExpandido(cat, 'receita') ? 'Recolher detalhes' : 'Expandir detalhes'"
                                                        (click)="$event.stopPropagation(); toggleDetalhesCategoria(cat, 'receita')">
                                                        <mat-icon>{{ isDetalhesCategoriaExpandido(cat, 'receita') ? 'expand_more' : 'chevron_right' }}</mat-icon>
                                                    </button>
                                                </td>
                                                @for (idx of mensalMesesIndicesTabela; track idx) {
                                                    <td class="col-matriz-val text-end">{{ getCatValor(cat, 'previstos', idx) > 0 ? formatarMoeda(getCatValor(cat, 'previstos', idx)) : '—' }}</td>
                                                    <td class="col-matriz-val text-end valor-receita-cat">{{ getCatValor(cat, 'realizados', idx) > 0 ? formatarMoeda(getCatValor(cat, 'realizados', idx)) : '—' }}</td>
                                                }
                                                <td class="col-matriz-val text-end col-cat-total"><strong>{{ formatarMoeda(getCategoriaTotal(cat, 'previstos')) }}</strong></td>
                                                <td class="col-matriz-val text-end col-cat-total valor-receita-cat"><strong>{{ formatarMoeda(getCategoriaTotal(cat, 'realizados')) }}</strong></td>
                                            </tr>
                                            @if (isDetalhesCategoriaExpandido(cat, 'receita')) {
                                                <tr class="categoria-expansao-row categoria-expansao-entrada" [style.--categoria-color]="getCategoriaDrillColor(cat)">
                                                    <td class="categoria-expansao-cell" [attr.colspan]="(mensalMesesIndicesTabela.length * 2) + 3">
                                                        <table class="detalhes-table detalhes-table-drill">
                                                            <thead>
                                                                <tr>
                                                                    <th class="col-data">Data</th>
                                                                    <th>Descrição</th>
                                                                    <th class="text-end">Valor</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                @for (mov of getMovimentacoesCategoria(cat); track mov.idMovimentacao) {
                                                                    <tr>
                                                                        <td class="col-data">{{ formatarData(mov.dataMovimentacao) }}</td>
                                                                        <td>{{ stripHtml(mov.descricao) }}</td>
                                                                        <td class="text-end valor-receita">{{ formatarMoeda(mov.valor) }}</td>
                                                                    </tr>
                                                                }
                                                                @if (getMovimentacoesCategoria(cat).length === 0) {
                                                                    <tr><td colspan="3" class="detalhes-empty">Sem lançamentos para esta categoria.</td></tr>
                                                                }
                                                            </tbody>
                                                        </table>
                                                    </td>
                                                </tr>
                                            }
                                        }
                                    }
                                }

                                <!-- Pagamentos section -->
                                <tr class="row-matriz-secao row-matriz-despesa" (click)="toggleMatrizSecao('pag')">
                                    <td class="col-matriz-desc">
                                        <button type="button" class="btn-matriz-collapse">
                                            <mat-icon>{{ isSecaoColapsada('pag') ? 'expand_more' : 'expand_less' }}</mat-icon>
                                        </button>
                                        <strong>Pagamentos</strong>
                                    </td>
                                    @for (idx of mensalMesesIndicesTabela; track idx) {
                                        <td class="col-matriz-val text-end">{{ getMensalValor('pagamentosPrevisto', idx) > 0 ? formatarMoeda(getMensalValor('pagamentosPrevisto', idx)) : '—' }}</td>
                                        <td class="col-matriz-val text-end valor-despesa">{{ getMensalValor('pagamentosRealizado', idx) > 0 ? formatarMoeda(getMensalValor('pagamentosRealizado', idx)) : '—' }}</td>
                                    }
                                    <td class="col-matriz-val text-end">
                                        <strong>{{ formatarMoeda(getTotalMensal('pagamentosPrevisto')) }}</strong>
                                    </td>
                                    <td class="col-matriz-val text-end valor-despesa">
                                        <strong>{{ formatarMoeda(getTotalMensal('pagamentosRealizado')) }}</strong>
                                    </td>
                                </tr>

                                @if (!isSecaoColapsada('pag')) {
                                    @for (cat of mensalResponse.categoriasDespesa; track cat.idCategoriaFinanceira) {
                                        @if (isCategoriaVisivel(cat, mensalResponse.categoriasDespesa, 'despesa')) {
                                            <tr [class.row-cat-nivel-0]="cat.nivel === 0"
                                                [class.row-cat-nivel-1]="cat.nivel === 1"
                                                [class.row-cat-nivel-2]="cat.nivel >= 2"
                                                class="categoria-row categoria-row-saida"
                                                [class.categoria-row-expanded]="isDetalhesCategoriaExpandido(cat, 'despesa')"
                                                [style.--categoria-color]="getCategoriaDrillColor(cat)"
                                                (click)="toggleDetalhesCategoria(cat, 'despesa')">
                                                <td class="col-matriz-desc td-categoria-tree" [style.padding-left.px]="20 + cat.nivel * 16">
                                                    @if (temFilhos(cat, mensalResponse.categoriasDespesa)) {
                                                        <mat-icon class="btn-cat-collapse" (click)="$event.stopPropagation(); toggleCategoria(cat, 'despesa')">{{ isCategoriaColapsada(cat, 'despesa') ? 'expand_more' : 'expand_less' }}</mat-icon>
                                                    } @else {
                                                        <span class="cat-indent-spacer"></span>
                                                    }
                                                    <span class="cat-color-dot" [style.background]="getCategoriaDrillColor(cat)"></span>
                                                    {{ cat.descricao }}
                                                    <button type="button" class="btn-cat-drill-toggle"
                                                        [attr.aria-label]="isDetalhesCategoriaExpandido(cat, 'despesa') ? 'Recolher detalhes' : 'Expandir detalhes'"
                                                        (click)="$event.stopPropagation(); toggleDetalhesCategoria(cat, 'despesa')">
                                                        <mat-icon>{{ isDetalhesCategoriaExpandido(cat, 'despesa') ? 'expand_more' : 'chevron_right' }}</mat-icon>
                                                    </button>
                                                </td>
                                                @for (idx of mensalMesesIndicesTabela; track idx) {
                                                    <td class="col-matriz-val text-end">{{ getCatValor(cat, 'previstos', idx) > 0 ? formatarMoeda(getCatValor(cat, 'previstos', idx)) : '—' }}</td>
                                                    <td class="col-matriz-val text-end valor-despesa-cat">{{ getCatValor(cat, 'realizados', idx) > 0 ? formatarMoeda(getCatValor(cat, 'realizados', idx)) : '—' }}</td>
                                                }
                                                <td class="col-matriz-val text-end col-cat-total"><strong>{{ formatarMoeda(getCategoriaTotal(cat, 'previstos')) }}</strong></td>
                                                <td class="col-matriz-val text-end col-cat-total valor-despesa-cat"><strong>{{ formatarMoeda(getCategoriaTotal(cat, 'realizados')) }}</strong></td>
                                            </tr>
                                            @if (isDetalhesCategoriaExpandido(cat, 'despesa')) {
                                                <tr class="categoria-expansao-row categoria-expansao-saida" [style.--categoria-color]="getCategoriaDrillColor(cat)">
                                                    <td class="categoria-expansao-cell" [attr.colspan]="(mensalMesesIndicesTabela.length * 2) + 3">
                                                        <table class="detalhes-table detalhes-table-drill">
                                                            <thead>
                                                                <tr>
                                                                    <th class="col-data">Data</th>
                                                                    <th>Descrição</th>
                                                                    <th class="text-end">Valor</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                @for (mov of getMovimentacoesCategoria(cat); track mov.idMovimentacao) {
                                                                    <tr>
                                                                        <td class="col-data">{{ formatarData(mov.dataMovimentacao) }}</td>
                                                                        <td>{{ stripHtml(mov.descricao) }}</td>
                                                                        <td class="text-end valor-despesa">−{{ formatarMoeda(mov.valor) }}</td>
                                                                    </tr>
                                                                }
                                                                @if (getMovimentacoesCategoria(cat).length === 0) {
                                                                    <tr><td colspan="3" class="detalhes-empty">Sem lançamentos para esta categoria.</td></tr>
                                                                }
                                                            </tbody>
                                                        </table>
                                                    </td>
                                                </tr>
                                            }
                                        }
                                    }
                                }

                                <!-- Transferências Entrada -->
                                <tr class="row-matriz-transferencia">
                                    <td class="col-matriz-desc"><strong>Transferências Entrada</strong></td>
                                    @for (idx of mensalMesesIndicesTabela; track idx) {
                                        <td class="col-matriz-val text-end">—</td>
                                        <td class="col-matriz-val text-end">{{ getMensalValor('transferenciasEntrada', idx) > 0 ? formatarMoeda(getMensalValor('transferenciasEntrada', idx)) : '—' }}</td>
                                    }
                                    <td class="col-matriz-val text-end">—</td>
                                    <td class="col-matriz-val text-end">
                                        <strong>{{ formatarMoeda(getTotalMensal('transferenciasEntrada')) }}</strong>
                                    </td>
                                </tr>

                                <!-- Transferências Saída -->
                                <tr class="row-matriz-transferencia">
                                    <td class="col-matriz-desc"><strong>Transferências Saída</strong></td>
                                    @for (idx of mensalMesesIndicesTabela; track idx) {
                                        <td class="col-matriz-val text-end">—</td>
                                        <td class="col-matriz-val text-end">{{ getMensalValor('transferenciasSaida', idx) > 0 ? formatarMoeda(getMensalValor('transferenciasSaida', idx)) : '—' }}</td>
                                    }
                                    <td class="col-matriz-val text-end">—</td>
                                    <td class="col-matriz-val text-end">
                                        <strong>{{ formatarMoeda(getTotalMensal('transferenciasSaida')) }}</strong>
                                    </td>
                                </tr>

                                <!-- Saldo do período -->
                                <tr class="row-matriz-saldo">
                                    <td class="col-matriz-desc"><strong>Saldo do Período</strong></td>
                                    @for (idx of mensalMesesIndicesTabela; track idx) {
                                        <td class="col-matriz-val text-end"
                                            [class.valor-receita]="getMensalValor('saldoPrevisto', idx) > 0"
                                            [class.valor-despesa]="getMensalValor('saldoPrevisto', idx) < 0">
                                            <strong>{{ formatarMoeda(getMensalValor('saldoPrevisto', idx)) }}</strong>
                                        </td>
                                        <td class="col-matriz-val text-end"
                                            [class.valor-receita]="getMensalValor('saldoRealizado', idx) > 0"
                                            [class.valor-despesa]="getMensalValor('saldoRealizado', idx) < 0">
                                            <strong>{{ formatarMoeda(getMensalValor('saldoRealizado', idx)) }}</strong>
                                        </td>
                                    }
                                    <td class="col-matriz-val text-end">—</td>
                                    <td class="col-matriz-val text-end"
                                        [class.valor-receita]="getSaldoFinalAno() > 0"
                                        [class.valor-despesa]="getSaldoFinalAno() < 0">
                                        <strong>{{ formatarMoeda(getSaldoFinalAno()) }}</strong>
                                    </td>
                                </tr>

                            </tbody>
                        </table>
                    </div>
                </article>

                <!-- Drill-down hint -->
                <div class="drill-hint">
                    <mat-icon>info_outline</mat-icon>
                    Dica: no modo <strong>Diário</strong>, selecione um mês específico para ver o detalhamento dia a dia.
                </div>
            }

        </section>

        } @else if (consultaGerada && !possuiResultados && mensagemEmptyState) {
            <section class="empty-state-card">
                <mat-icon>search_off</mat-icon>
                <p>{{ mensagemEmptyState }}</p>
            </section>
        }

        }
    </div>
</div>
